<template>
  <div
    class="popup-container"
    id="popupContainer"
    :style="this.$store.state.style"
    v-bind:class="{ opened: openActionMenue }"
  >
    <div class="popup" style="color: black">
      <button
        type="button"
        v-on:click="hideActions()"
        class="close"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>

      <ul
        v-for="msgSetting in messageAppsSettings"
        v-bind:key="msgSetting.nodeName"
      >
        <li
          class="fontStyle"
          v-if="appHasMessage(msgSetting)"
          v-on:click="showAppMessages(msgSetting)"
        >
          {{ msgSetting.nodeName }}
        </li>
      </ul>

      <div
        class="submenu"
        id="subMenu"
        v-if="currentSelectedApp"
        v-bind:class="{ opened: openSubMenu }"
      >
        <button v-on:click="hideSubMenue()" class="back">
          <i class="fa fa-chevron-left"></i> Back
        </button>

        <span class="appname fontStyle float-none">{{
          currentSelectedApp.nodeName
        }}</span>

        <ul v-for="g in groupedAppMessages" v-bind:key="g.messageType">
          <li v-if="g.showBasedOnSettings">
            {{ g.messageType }}
            <ul v-for="grp in g.messages" v-bind:key="grp.groupId">
              <li
                class="custom-control custom-checkbox"
                v-if="g.showBasedOnSettings"
              >
                <!--main group or single-->
                <input
                  class="custom-control-input"
                  v-show="!g.isRadio"
                  :type="g.isRadio ? 'radio' : 'checkbox'"
                  :id="grp.groupId"
                  :value="grp.groupId"
                  :checked="isGroupSelected(grp)"
                  @change="groupSelected(grp, $event, g.isRadio)"
                />

                <label
                  class="custom-control-label"
                  v-show="!g.isRadio"
                  :for="grp.groupId"
                  >{{ grp.groupName }}</label
                >
                <span class="tooltiptext">{{ grp.groupName }}</span>
                <!-- group's item-->
                <ul v-for="msg in grp.groupChild" v-bind:key="msg.msgId">
                  <li
                    class="custom-control custom-checkbox"
                    v-if="msg.messageGroupId == grp.groupId || g.isRadio"
                  >
                    <input
                      class="custom-control-input"
                      :type="g.isRadio ? 'radio' : 'checkbox'"
                      :id="msg.msgId"
                      :value="msg"
                      :checked="isSubGroupSelected(msg)"
                      @change="groupSelected(msg, $event, g.isRadio)"
                      :name="grp.groupId"
                    />
                    <label class="custom-control-label" :for="msg.msgId">{{
                      msg.name
                    }}</label>
                    <span class="tooltiptext">{{ msg.name }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <button
          v-if="!returnMode"
          class="launch-btn"
          :disabled="!enableLaunch"
          @click.prevent="sendMessages"
        >
          Launch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "Actions",

  data: function () {
    return {
      currentSelectedApp: null,
      selectedMessages: [],
      openSubMenu: false,
    };
  },

  props: [
    "openActionMenue",
    "appMessages",
    "messageAppsSettings",
    "returnMode",
  ],

  methods: {
    isGroupSelected(group) {
      var groupChildrenCount = group.groupChild.length;
      var groupSeelectedMessagesCount = 0;
      _.forEach(this.selectedMessages, (item) => {
        if (item.messageGroupId === group.groupId)
          groupSeelectedMessagesCount++;
      });

      return groupChildrenCount === groupSeelectedMessagesCount;
    },
    isSubGroupSelected(msg) {
      var index = _.findIndex(this.selectedMessages, (item) => {
        return item.msgId === msg.msgId;
      });
      return index != -1;
    },
    hideSubMenue: function () {
      this.openSubMenu = false;
      this.selectedMessages = [];
    },

    groupSelected(group, event, isRadio) {
      let nodeName = this.currentSelectedApp.nodeName;
      let isChecked = event.target.checked;
      if (isRadio) {
        this.selectedMessages = [group];
        this.selectedMessages[0].nodeName = nodeName;
      } else {
        let isParent = group.hasOwnProperty("groupId");

        if (isChecked) {
          var selectedMessagesTypes = _.map(
            _.uniq(this.selectedMessages, "messageType"),
            "messageType"
          );

          var messageType = group.msgType ? group.msgType : group.messageType;
          if (
            selectedMessagesTypes.length &&
            _.indexOf(
              _.map(
                _.uniq(this.selectedMessages, "messageType"),
                "messageType"
              ),
              messageType
            ) === -1
          ) {
            event.target.checked = false;
            this.$toastr.w(
              "Please make sure all selections are of the same type"
            );
            return;
          }
        }

        if (isParent) {
          // if they are the same then no child exists
          if (isChecked) {
            if (group.groupId == group.groupName) {
              this.selectedMessages.push(
                this.appMessages.filter((m) => m.groupId == group.groupId)[0]
                  .groupChild[0]
              );
            } else {
              this.selectedMessages.push(
                ...this.appMessages.filter((g) => g.groupId == group.groupId)[0]
                  .groupChild
              );
            }
          } else {
            if (group.groupId == group.groupName) {
              this.selectedMessages = this.selectedMessages.filter(
                (m) => m.messageGuid != group.groupChild[0].messageGuid
              );
            } else {
              this.selectedMessages = this.selectedMessages.filter(
                (m) => m.messageGroupId != group.groupId
              );
            }
          }
        } else {
          //the group has childs needs to be added to selected messages
          if (isChecked) {
            this.selectedMessages = this.selectedMessages.concat(group);
          } else {
            this.selectedMessages = this.selectedMessages.filter(
              (m) => m.msgId != group.msgId
            );
          }
        }
        this.selectedMessages.forEach((m) => {
          m.nodeName = nodeName;
        });
      }
    },

    hideActions: function () {
      this.$emit("close-action-menue");
    },

    appHasMessage: function (appSettings) {
      let that = this;
      let show = false;
      appSettings.nodeSettings.some((setting) => {
        if (
          that.appMessages.filter((m) => m.msgType == setting.messageType)
            .length > 0
        ) {
          show = true;
          return show;
        }
      });
      return show;
    },

    showAppMessages: function (msgSetting) {
      let that = this;
      that.currentSelectedApp = msgSetting;
      that.hideAllMessages();
      that.updateMessagesForApp(that.currentSelectedApp);
      that.openSubMenu = true;
    },

    hideAllMessages: function () {
      let that = this;
      that.groupedAppMessages.forEach((g) => (g.showBasedOnSettings = false));
    },

    sendMessages: function () {
      if (this.selectedMessages instanceof Array) {
        let messagesType = this.selectedMessages.map((x) => x.messageType);
        if (
          messagesType.length > 1 &&
          messagesType.length == _.uniq(messagesType).length
        ) {
          alert("can you please select messages of same type");
        } else {
          this.sendSelectedMessage();
        }
      } else {
        this.sendSelectedMessage();
      }
    },

    sendSelectedMessage() {
      this.hideActions();
      this.hideAllMessages();
      this.$emit(
        "message-selected",
        [].concat(this.selectedMessages),
        this.currentSelectedApp.nodeId,
        this.currentSelectedApp.nodeSettings[0].messageReturnMode // ReturnMode
      );
      this.hideSubMenue();
    },
    updateMessagesForApp: function (AppSettings) {
      let that = this;
      AppSettings.nodeSettings.forEach((setting) => {
        that.groupedAppMessages
          .filter((g) => g.messageType == setting.messageType)
          .forEach((g) => {
            (g.showBasedOnSettings = true),
              (g.isRadio = setting.messageItemCount == 1 ? true : false);
          });
      });
    },
  },

  computed: {
    groupedAppMessages: function () {
      let newGroupedArr = [];
      this.appMessages.forEach((msg) => {
        let groupIndex = newGroupedArr.findIndex(
          (m) => m.messageType == msg.msgType
        );
        if (groupIndex >= 0) {
          newGroupedArr[groupIndex].messages.push(msg);
        } else {
          newGroupedArr.push({
            messageType: msg.msgType,
            messages: [].concat(msg),
            showBasedOnSettings: false,
            isRadio: false,
          });
        }
      });
      return newGroupedArr;
    },

    enableLaunch: function () {
      if (this.selectedMessages instanceof Array) {
        return this.selectedMessages.length > 0 ? true : false;
      } else {
        return this.selectedMessages ? true : false;
      }
    },
  },

  watch: {
    appMessages: function () {
      if (this.openSubMenu) {
        this.updateMessagesForApp(this.currentSelectedApp);
      }
    },
  },
};
</script>


<style>
/* li {
  cursor: pointer;
} */
.slide-text-part h4 {
  font-size: 18px;
}

.slide-text-part img,
.slide-text-part h3 {
  cursor: pointer;
}

.slide-text-part button {
  background: var(--openApp_btn);
  border: 0;
  color: var(--openApp_btn_text);
  font-size: 14px;
  font-weight: var(--openApp_btn_fontweight);
  border-radius: var(--openApp_btn_borderRadius);
  height: 40px;
  padding: 0 25px;
  position: absolute;
  bottom: var(--openApp_btn_position_btm);
  left: var(--btn_position);
  transform: var(--btn_transform);
  opacity: var(--card_p_display);
}

.slide-text-part button img {
  display: var(--arrow_display);
  margin-left: 10px;
  position: absolute;
  top: 10px;
}

.slide-text-part button:focus {
  outline: none;
}

.appname {
  float: right;
}

.fontStyle {
  color: #133d5e;
  border-radius: 5px;
  font-weight: bold;
}
.submenu li label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
  margin: 0px 0px -5px 0;
}
.submenu li {
  position: relative;
}

.submenu li .tooltiptext {
  display: none;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 20%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 14px;
  line-height: 18px;
}

.submenu li .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.submenu li label:hover + .tooltiptext {
  display: block;
  opacity: 1;
}
.custom-control.custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  border-color: #787879 !important;
  background-color: #fff !important;
}
.custom-control-label::after,
.custom-control-label::before,
.custom-control-label::after {
  width: 18px !important;
  height: 18px !important;
  left: 0 !important;
  background-color: #fff !important;
}
.custom-control-label {
  font-size: 13px;
  line-height: 21px !important;
}
.custom-control.custom-checkbox {
  padding: 0;
  font-size: 14px;
  /* margin-left: 15px; */
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #787879 !important;
  background-color: #fff !important;
}
li ul li.custom-control.custom-checkbox label {
  padding-left: 25px;
  font-size: 14px;
}
.custom-checkbox .custom-control-label::before,
.custom-checkbox .custom-control-label::after {
  border-radius: 0 !important;
  border: solid 1px #787879;
  top: 0;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../../assets/images/checkbox-icon.png") !important;
  background: no-repeat 50%;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none !important;
  -webkit-tap-highlight-color: red;
}
.custom-checkbox
  .custom-control-input:indeterminate
  ~ .custom-control-label::after {
  background-image: none !important;
  background: #fff !important;
}
.custom-checkbox input[type="radio"] + .custom-control-label::before,
.custom-checkbox input[type="radio"] + .custom-control-label::after {
  border-radius: 50% !important;
}
.custom-checkbox
  .custom-control-input[type="radio"]:checked
  ~ .custom-control-label::after {
  background-image: url("../../assets/images/radiobutton-icon.png") !important;
  background: no-repeat 50%;
}
</style>